import http from '@/http'

export default {
  logAttempt: client_ip => http.post('/api/payment-attempts', { client_ip })
}
